module.exports = __webpack_public_path__ + "59c82f78462f613b6063d242700ea999.png";